import { apiNet } from '@cems-eco/core/src/services/api';
import { ReportFilter, ReportFormat } from './index';
import { BaseReportApi } from './api.base';

export class CloudReportApi extends BaseReportApi {

    async allByEquipment(equipmentId: any): Promise<any> {
        const url = this.BASE_URL + '/equipment/' + equipmentId + '/30m';
        return await apiNet.get<any>(url);
    }

    async header(reportFilter: ReportFilter): Promise<any> {
        const url = this.BASE_URL + '/header';
        return await apiNet.post<any>(url, reportFilter);
    }

    async allByReportFilter(reportFilter: ReportFilter, format: ReportFormat, additionalParam: any = {}): Promise<any> {
        let uri = apiNet.toSerialize(reportFilter);
        if (Object.keys(additionalParam).length) {
            uri = uri + `&${apiNet.toSerialize(additionalParam)}`;
            const url = this.BASE_URL + '/' + format.toString() + encodeURI(uri);

            return await apiNet.get<any>(url);
        } else {
            const url = this.BASE_URL + '/' + format.toString() + encodeURI(uri);
            return await apiNet.get<any>(url);
        }
    }

    async all(): Promise<any> {
        return await apiNet.get<any>(this.BASE_URL);
    }

    async first(id: any): Promise<any> {
        return await apiNet.get<any>(`${this.BASE_URL}/${id}`);
    }

    async create(data: any): Promise<any> {
        return await apiNet.post<any>(this.BASE_URL, data);
    }

    async edit(id: any, data: any): Promise<any> {
        return await apiNet.put<any>(`${this.BASE_URL}/${id}`, data);
    }

    async destroy(id: any): Promise<any> {
        return await apiNet.delete<any>(`${this.BASE_URL}/${id}`);
    }

    async download(reportFilter: ReportFilter, format: ReportFormat, fileName: string): Promise<any> {
        const uri = apiNet.toSerialize(reportFilter);
        const url = this.BASE_URL + '/' + format.toString() + '?' + encodeURI(uri);
        return await apiNet.downloadFile<any>(url, fileName);
    }

    async sensorByEquipment(equipment_id: any): Promise<any> {
        const params = {
            search: {
                advanced: {
                    equipment_id
                }
            }
        }
        return await apiNet.get<any>(`/sensor`, params);
    }

    getUrl(url, params = {}): string {
        return apiNet.getUrl(url, params);
    }

    async getOptions(url, params = {}, keyValue = 'id'): Promise<any[]> {
        let response = await apiNet.get<any>(url, params);
        return (response.data as any[]).map((e) => ({
            label: e.text,
            value: e[keyValue],
        }));
    }

}
